import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import { ShowIf } from 'components/utils';
import { get } from 'lodash';

class RowItemDoiTuongThanhTra extends React.Component {

  handleEdit() {
    this.props.handleEdit(this.props.item.doiTuongViPhamId);
  }

  render() {
    let titleButton = 'Chỉnh sửa';
    if (this.props.item.trangThaiDoiTuongViPhamInfo && this.props.item.trangThaiDoiTuongViPhamInfo.type == 'HOAN_THANH') {
      titleButton = 'Bổ sung thông tin';
    }
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ten ? this.props.item.ten : ''}</td>
        <td>{get(this.props.item, 'linhVucKetQuaThanhTra.ten', '')}</td>
        <td>{this.props.item.trangThaiDoiTuongViPhamInfo ? this.props.item.trangThaiDoiTuongViPhamInfo.text : ''}</td>
        <td>
          <div className="todo-wrap two-item">
            <div className="wrap-link-todo">
              <Link className="itt-edit" onClick={this.handleEdit.bind(this)}>{titleButton}</Link>
            </div>
            <ShowIf condition={this.props.item.trangThaiDoiTuongViPhamInfo.type != 'HOAN_THANH'}>
              <DeleteDialog
                title={'Xác nhận'}
                content={`Bạn có đồng ý xóa đối tượng vi phạm này không?`}
                redux={this.props.parent}
                deleteId={this.props.item.doiTuongViPhamId}
              />
            </ShowIf>
          </div>
        </td>
      </tr>
    );
  }
}

RowItemDoiTuongThanhTra.defaultProps = {
  handleEdit: function() {
    console.log('Need append handleEdit menthod');
  }
}

export default RowItemDoiTuongThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDoiTuongThanhTra.jsx